import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'pr-panel',
    templateUrl: './pr-panel.component.html',
    styleUrls: ['./pr-panel.component.scss'],
    standalone: false
})
export class PrPanelComponent {
  @Input() clazz: string;
  @Input() load: boolean;

  constructor() {}
}
